import coreProjectionJson from './Core.json' with { type: 'json' };
export const coreProjection = coreProjectionJson;
